module.exports = __webpack_public_path__ + "static/fonts/iconfont.66b6044.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font/iconfont.ttf?t=1780902215335
// module id = 7lWX
// module chunks = 143